<template>
	<div class="content">
		<div class="loading-overlay" :class="show ? 'is-active' : ''">
			<span class="fas fa-spinner fa-3x fa-spin"></span>
		</div>
		<div v-if="rendered" class="container-fluid">
			<div class="row">
				<div class="col-lg-6">
					<div>
						<div
							class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white"
						>
							<a
								href="/"
								class="marineBg d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
							>
								<h2 class="mt-0 mb-0">Chat</h2>
							</a>
							<div
								id="chatCorpo"
								class="list-group list-group-flush border-bottom scrollarea"
							>
								<div aria-current="true" v-for="(msg, i) in mensagens" :key="i">
									<div
										:class="
											msg.user_id == utilizador.user_id ? 'minhaMensagem' : ''
										"
										class="list-group-item list-group-item-action py-3 lh-tight"
									>
										<div class="d-flex w-100">
											<div class="col-6 text-left paddingRL" style="float:left">
												<strong class="mb-1">{{ msg.username }}</strong>
											</div>
											<div
												class="col-6 text-right paddingRL"
												style="float:right"
											>
												<strong class="mb-1">{{ msg.dt_created }}</strong>
											</div>
										</div>
										<div class="d-flex w-100 align-items-center">
											<div>
												{{ msg.mensagem }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card" style="border: 1px solid #d9d9d9 !important;">
							<textarea
								id="enviarMensagem"
								class="form-control mt-3 p-3 text-dark"
								placeholder="Escreva a mensagem e pressiona Enter para enviar"
								type="text"
								v-model="mensagem"
								v-on:keyup.enter="submeter()"
							></textarea>
						</div>
					</div>
				</div>

				<div class="col-lg-6">
					<h2 class="marineBg text-left text-white mb-0 mt-0 p-3">
						Mostre-nos o seu dia
					</h2>
					<div class="card p-3">
						<div class="mt-2">
							<image-upload
								id="upload"
								type="avatar"
								select-text="Carregar imagem"
								@change="onAvatarChange"
							/>
						</div>
						<div class="mt-2 pb-5">
							<div>
								<ul class="imageGallery">
									<li
										style="width: 125px; height: 125px;"
										v-for="(item, index) in images"
										:key="index"
									>
										<!-- SECURITY COMMENT <a
											:href="item.link"
											@click="
												lightboxOpen(item.link, item.descricao, index, $event)
											"
											:class="{ active: active == index }"
										> 
											<img
												style="height:100% !important"
												:src="item.link"
												:alt="item.descricao"
											/>
										</a> -->
										<i
											@click="apagarImagem(item)"
											v-if="
												utilizador.user_id == item.user_id ||
													utilizador.nivel == 1
											"
											class="tim-icons icon-trash-simple pointer"
											style="color:red"
										></i>
									</li>
								</ul>

								<div
									id="overlay"
									style="z-index:9999"
									@click.self="closeOverlay"
								>
									<div class="holder">
										<img id="overlay_image" />
										<div class="nav">
											<a id="close" nohref @click="closeOverlay"
												><span>×</span></a
											>
											<a id="prev" nohref @click="cyclePrev"><span>←</span></a>
											<a id="next" nohref @click="cycleNext"><span>→</span></a>
										</div>
										<p id="overlay_caption"></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal
			:show.sync="modalUpload"
			footerClasses="justify-content-center "
			type="notice"
			persistent
		>
			<div class="instruction">
				<div class="row mt-3">
					<div class="col-md-12 text-center">
						<div class="form-group text-left">
							<label class="form-control-label"
								>Insira uma breve descrição sobre a fotografia:</label
							>
							<textarea
								rows="4"
								class="form-control"
								placeholder="Descrição"
								v-model="descricao"
								style="max-height: 150px !important; height: 150px !important;"
							></textarea>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="justify-content-center">
				<base-button
					class="mb-3 bg_edp_verde"
					size="lg"
					simple
					type="success"
					@click="upload"
					>Enviar</base-button
				>
			</div>
		</modal>
	</div>
</template>

<script>
	import Pusher from "pusher-js";
	import api from "@/api/index";
	import { ImageUpload, Modal } from "@/components/index";
	export default {
		components: {
			ImageUpload,
			Modal,
		},
		data() {
			return {
				descricao: "",
				ficheiroCarregado: [],
				rendered: false,
				show: true,
				ficheiro: false,
				galleryTitle: "Vue Gallery Component",
				showNav: 1,
				keyBoardNav: 1,
				showcaption: 1,
				loop: 1,
				images: [],
				allowKeyboard: 1,
				imageIndex: 0,
				active: 0,
				utilizador: [],
				mensagem: "",
				mensagens: [],
				modalUpload: false,
			};
		},
		methods: {
			async apagarImagem(array) {
				var index = this.images.indexOf(array);
				this.images.splice(index, 1);
				await api.apagarImagem(array);
			},
			async upload() {
				if (this.descricao != "") {
					var file = this.ficheiroCarregado;
					if (file) {
						this.ficheiroCarregado = file;
						this.ficheiro = true;
						var _this = this;
						if (file) {
							var formato = file.type.replace(/(.*)\//g, "");
							if (formato == "jpeg") {
								formato = "jpg";
							}
							if (formato != "jpg" && formato != "png") {
								_this.notifyVueErro(
									"top",
									"right",
									"Apenas são permitidos ficheiros jpg e pdf"
								);
								return;
							}
							var nomeFicheiro = this.utilizador.user_id + Date.now();
							var path =
								"https://yourcode-staging.com/niu-mensagens/imagens/" +
								this.user_id;
							var fullPath = path + "/" + nomeFicheiro + "." + formato;

							const form_data = new FormData();
							form_data.append("file", file);
							form_data.append("nome", nomeFicheiro);
							await fetch(
								"https://yourcode-staging.com/niu-mensagens/file.php",
								{
									method: "POST",
									body: form_data,
								}
							)
								.then(function(response) {
									return response.text();
								})
								.then(async function(responseData) {
									if (responseData) {
										var url =
											"https://yourcode-staging.com/niu-mensagens/imagens/" +
											responseData;
										let json = {
											user_id: _this.utilizador.user_id,
											nome: _this.utilizador.nome,
											descricao: _this.descricao,
											active: 0,
											link: url,
										};
										let res = await api.uploadImagem(json);
										if (res.resultado == "OK") {
											_this.images.splice(0, 0, json);
											document.getElementById("upload").value = "";
											_this.modalUpload = false;
											_this.descricao = "";
											_this.ficheiro = false;
										}
									}
								});
						} else {
							this.ficheiro = false;
						}
					}
				} else {
					//MENSAGEM ERRO
				}
			},
			async onAvatarChange(file) {
				if (file) {
					this.ficheiroCarregado = file;
					this.modalUpload = true;
				}
			},
			lightboxOpen(href, caption, index, event) {
				event.preventDefault();
				document.getElementById("overlay_image").src = href;
				document.getElementById("overlay_caption").innerHTML = caption;
				this.allowKeyboard = 1;
				document.getElementById("overlay").style.display = "flex";
				this.imageIndex = index;
				this.active = index;
			},
			closeOverlay() {
				document.getElementById("overlay").style.display = "none";
				this.allowKeyboard = 0;
			},
			cycleNext() {
				if (this.images.length != this.imageIndex + 1) {
					var nextActiveImage = document
						.querySelector(".imageGallery .active")
						.parentElement.nextSibling.querySelector("img");
					nextActiveImage.click();
				} else if (this.loop == 1) {
					var firstActiveImage = document
						.querySelector(".imageGallery")
						.querySelector("li")
						.querySelector("img");
					firstActiveImage.click();
				}
			},
			cyclePrev() {
				if (this.imageIndex != 0) {
					var prevActiveImage = document
						.querySelector(".imageGallery .active")
						.parentElement.previousSibling.querySelector("img");
					prevActiveImage.click();
				} else if (this.loop == 1) {
					var lastActiveImage = document
						.querySelector(".imageGallery")
						.querySelectorAll("li");
					var lastChild = lastActiveImage[
						lastActiveImage.length - 1
					].querySelector("img");
					lastChild.click();
				}
			},
			async submeter() {
				if (this.mensagem == "") {
					return;
				}
				var user_id = localStorage.getItem("active-session-niu");
				var currentdate = new Date();
				var mes = currentdate.getMonth() + 1;
				var dia = currentdate.getDate();
				var horas = currentdate.getHours();
				var minutos = currentdate.getMinutes();
				var segundos = currentdate.getSeconds();
				if (dia.toString().length == 1) {
					dia = "0" + dia.toString();
				}
				if (mes.toString().length == 1) {
					mes = "0" + mes.toString();
				}
				if (horas.toString().length == 1) {
					horas = "0" + horas.toString();
				}
				if (minutos.toString().length == 1) {
					minutos = "0" + minutos.toString();
				}
				if (segundos.toString().length == 1) {
					segundos = "0" + segundos.toString();
				}
				var datetime =
					currentdate.getFullYear() +
					"-" +
					mes +
					"-" +
					dia +
					" " +
					horas +
					":" +
					minutos +
					":" +
					segundos;
				var _this = this;
				let envioJson = {
					user_id: this.utilizador.user_id,
					username: this.utilizador.nome,
					mensagem: this.mensagem,
				};
				let envio = await api.registarMensagem(envioJson);

				if (envio.resultado == "OK") {
					var formdata = new FormData();
					formdata.append("username", _this.utilizador.nome);
					formdata.append("mensagem", _this.mensagem);
					formdata.append("dt_created", datetime);
					formdata.append("user_id", user_id);

					var requestOptions = {
						method: "POST",
						body: formdata,
						redirect: "follow",
					};

					await fetch(
						"https://yourcode-staging.com/niu-mensagens/index.php",
						requestOptions
					);
					var elem = document.getElementById("chatCorpo");
					elem.scrollTop = elem.scrollHeight;
					_this.mensagem = "";
				}
			},
		},
		async mounted() {
			this.$router.push("/");

			var _this = this;
			Pusher.logToConsole = false;

			const pusher = new Pusher("e00355a111abb8c58e5b", {
				cluster: "eu",
			});

			const channel = pusher.subscribe("chat");
			channel.bind("mensagem", async (data) => {
				_this.mensagens.push(data);
			});

			var user_id = localStorage.getItem("active-session-niu");
			var jsonUser = {
				user_id: user_id,
			};

			let res = await api.buscarDados(jsonUser);
			if (Object.values(res).length > 0) {
				this.utilizador = Object.values(res)[0];
			}
			// BUSCAR IMAGENS
			let resImagens = await api.buscarImagens();
			resImagens = Object.values(resImagens).sort((a, b) => {
				return Number(a.id) > Number(b.id) ? -1 : 1;
			});
			this.images = resImagens;

			//BUSCAR MENSAGENS
			let resMensagens = await api.buscarMensagens();
			resMensagens = Object.values(resMensagens).sort(function(a, b) {
				return Number(a.id) > Number(b.id) ? 1 : -1;
			});
			this.mensagens = resMensagens;
			this.rendered = true;
			setTimeout(() => {
				var elem = document.getElementById("chatCorpo");
				if (elem) {
					elem.scrollTop = elem.scrollHeight;
				}
			}, 1500);
			this.show = false;
		},
	};
</script>
<style lang="scss">
	@import url("https://fonts.googleapis.com/css?family=Lato");
	$primaryFont: "Lato", sans-serif;
	.minhaMensagem {
		background-color: #d9fdd3;
		border-radius: 5px;
		padding: 5px;
	}
	body {
		font-family: $primaryFont;
		background: #ffffff;

		h1 {
			color: #000;
			text-align: center;
		}
	}
	.paddingRL {
		padding-right: 0px;
		padding-left: 0px;
	}
	.imageGallery {
		list-style: none;
		margin: 0 auto;
		padding: 0;
		display: block;
		max-width: 780px;
		text-align: center;

		li {
			display: inline-block;
			padding: 8px;
			background: ghostwhite;
			margin: 10px;

			a {
				text-decoration: none;

				img {
					display: block;
					width: 200px;
				}
			}
		}
	}

	#overlay {
		display: none;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.9);
		text-align: center;
		padding: 20px;
		box-sizing: border-box;

		.holder {
			margin: auto;

			img {
				width: 100%;
				height: 100% !important;
				max-width: 600px;
				cursor: pointer;
				box-sizing: border-box;
				display: block;
			}

			p {
				color: #ffffff;
				margin: 0;
				background-color: rgba(0, 0, 0, 0.4);
				position: relative;
				bottom: 0;
				left: 0;
				right: 0;
				box-sizing: border-box;
				padding: 10px;
			}
			.nav {
				max-width: 600px;
				margin: 0 auto;
				font-size: 14px;

				a {
					color: white;
					// opacity: 0.3;
					-webkit-user-select: none;
					cursor: pointer;

					&:hover {
						opacity: 1;
					}
				}

				#next,
				#prev {
					position: absolute;
					top: 0;
					bottom: 0;
					padding: 10px;
					width: 50%;
					box-sizing: border-box;
					font-size: 40px;

					span {
						top: 50%;
						transform: translateY(50%);
						position: relative;
					}
				}

				#next {
					right: 0;
					text-align: right;
				}

				#prev {
					left: 0;
					text-align: left;
				}
				#close {
					right: 10px;
					top: 0;
					font-size: 30px;
					opacity: 0.6;
					z-index: 1000000;
					position: absolute;
					text-align: left;
					box-sizing: border-box;

					&:hover {
						opacity: 1;
					}
				}
			}
		}
	}
	.gallery-block.grid-gallery {
		padding-bottom: 60px;
		padding-top: 60px;
	}

	.gallery-block.grid-gallery .heading {
		margin-bottom: 50px;
		text-align: center;
	}

	.gallery-block.grid-gallery .heading h2 {
		font-weight: bold;
		font-size: 1.4rem;
		text-transform: uppercase;
	}

	.gallery-block.grid-gallery a:hover {
		opacity: 0.8;
	}

	.gallery-block.grid-gallery .item img {
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
		transition: 0.4s;
	}

	.gallery-block.grid-gallery .item {
		margin-bottom: 20px;
	}

	@media (min-width: 576px) {
		.gallery-block.grid-gallery .scale-on-hover:hover {
			transform: scale(1.05);
			box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.15) !important;
		}
	}
	.scrollarea {
		max-height: 60vh;
		overflow: auto;
	}

	.form-control::placeholder,
	.form-group .el-input__inner::placeholder,
	.el-date-picker .el-input .el-input__inner::placeholder {
		color: #fff;
	}

	.imageGallery {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.imageGallery li {
		text-align: center !important;
	}

	.minhaMensagem {
		padding: 15px;
	}

	#enviarMensagem::placeholder {
		color: #ccc !important;
		font-size: 14px;
	}
</style>
